import { useEffect, useState, type ReactNode } from 'react';

function useAuthenticatedMediaUrl(url: string | null): string | null {
  const [src, setSrc] = useState(url);

  useEffect(() => {
    setSrc(url);
    if (!url || !url.startsWith('/api/')) {
      return undefined;
    }
    const token = localStorage.getItem('token');
    if (!token) {
      return undefined;
    }
    const controller = new AbortController();
    let objectUrl: string | null = null;
    fetch(url, { headers: { Authorization: `Bearer ${token}` }, signal: controller.signal })
      .then(response => (response.ok ? response.blob() : Promise.reject()))
      .then(blob => {
        objectUrl = URL.createObjectURL(blob);
        setSrc(objectUrl);
      })
      .catch(() => {
        setSrc(url);
      });
    return () => {
      controller.abort();
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [url]);

  return src;
}

export function AuthenticatedMedia({
  url,
  children,
}: {
  url: string;
  children: (src: string) => ReactNode;
}) {
  const src = useAuthenticatedMediaUrl(url);
  return <>{src ? children(src) : null}</>;
}
